import React from 'react';

const JS_2020 = () => {
  return (
    <div >
      <h1>JS_2020</h1>
      <p>Placeholder component for: "JS 2020"</p>
    </div>
  );
};

export default JS_2020;
